import type EnType from '../en-US/apiRunnerSplitPane';

export default {
  'apiRunnerSplitPane.request': 'Requestエディタ',
  'apiRunnerSplitPane.response': 'Response',
  'apiRunnerSplitPane.vertical': '縦に分割する',
  'apiRunnerSplitPane.horizontal': '横に分割する',
  'apiRunnerSplitPane.none': '分割しない',
} satisfies typeof EnType;
